import { render, staticRenderFns } from "./payoutsLogs.pug?vue&type=template&id=0d8bc41f&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./payoutsLogs.scss?vue&type=style&index=0&id=0d8bc41f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8bc41f",
  null
  
)

export default component.exports